var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'check-cell-content btl': !_vm.isRtype }},[_c('creditcard-info',{attrs:{"is-rtype":_vm.isRtype}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }